import {Component, ElementRef, Host, Inject, Input, OnInit, Optional, Self, ViewChild} from '@angular/core';
import {UIBaseControlComponent} from "../ui-base-control/ui-base-control.component";
import {NgControl, NgModel, ValidationErrors} from "@angular/forms";
import {UI_INPUT_VALIDATION_ERROR_TOKEN} from "../ui-base-control/ui-input-validation-error-token";

@Component({
  selector: 'ui-input-password',
  templateUrl: './ui-input-password.component.html',
  styleUrls: ['./ui-input-password.component.scss']
})
export class UIInputPasswordComponent extends UIBaseControlComponent implements OnInit{
  passwordVisible = false;
  passwordMask = new Array(140).fill(/[^А-яЁё]/);
  errors = [];
  @ViewChild('input', { static: true })
  input: ElementRef;
  @Input() placeholder: string = 'password';
  
  constructor(
    @Self()
    @Optional()
    public ngControl: NgControl,
    @Optional()
    @Host()
    @Inject(UI_INPUT_VALIDATION_ERROR_TOKEN)
    public customErrors: ValidationErrors
  ) {
    super(ngControl, customErrors);
  }
  private onInputChange() {
    const input = this.input.nativeElement;
    // get value from text area
    const newValue = input.value;

    // update the form
    this.onChange(newValue);
  }

  ngOnInit(): void {
    super.ngOnInit();

    // support for value change by [(ngModel)]
    if (this.ngControl instanceof NgModel) {
      const inputElement = this.input.nativeElement;
      inputElement.onchange = () => this.onInputChange();
      inputElement.onkeyup = () => this.onInputChange();
    }
    /*if (this.formControl.value) {
      const conformedValue = conformToMask(this.formControl.value, this.phoneMaskFunction, { pipe: this.phonePipe.bind(this) }).conformedValue;
      this.formControl.setValue(conformedValue, { emitEvent: false });
    }*/
  }

}
